import React from "react";
import Button from "@material-ui/core/Button";
import {Attachment} from "../SharedTypes";

export function WPMedia({attachment, onChange, label, additionalButtons}: {
    attachment?: Attachment, label?: string
    onChange: (newValue: Attachment) => any
    additionalButtons?: any
}) {
    return <div style={{marginBottom: '1rem', textAlign: 'center'}}>
        {attachment
            ? <div>
                <img src={attachment.url} alt={`Attachment ${attachment.id || ''}`}
                     style={{maxWidth: '100%', maxHeight: 320, display: 'inline-block'}}/>
            </div> : null}
        {additionalButtons}
        <Button color="primary" onClick={async () => {
            onChange(await selectImage(attachment));
        }}>
            {attachment ? 'Edit' : 'Select'} {label || 'Image'}
        </Button>
    </div>
}

export function selectImage(attachment?: Attachment): Promise<Attachment> {
    return new Promise(resolve => {
        const wp = (window as any).wp as any;
        if (attachment) {
            wp.media.model.settings.post.id = attachment?.id;
        }
        // Create the media frame.
        const file_frame = wp.media.frames.file_frame = wp.media({
            title: 'Select a image to upload',
            button: {text: 'Use this image'},
            multiple: false	// Set to true to allow multiple files to be selected
        });

        if (attachment) {
            file_frame.on('open', function () {
                const selection = file_frame.state().get('selection');
                const attachmentObj = wp.media.attachment(attachment.id);
                attachmentObj.fetch();
                selection.add(attachmentObj ? [attachmentObj] : []);
            });
        }
        // When an image is selected, run a callback.
        file_frame.on('select', function () {
            // We set multiple to false so only get one image from the uploader
            const attachment = file_frame.state().get('selection').first().toJSON();

            // Do something with attachment.id and/or attachment.url here
            resolve({id: attachment.id, url: attachment.url} as Attachment);
        });
        // Finally, open the modal
        file_frame.open();
    });
}